import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import { startLenis } from "./lib/site";

function App() {
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  const Router = window.location.protocol === "file:" ? HashRouter : BrowserRouter;

  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacidade" element={<Privacy />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Router>
      </div>
    </MotionConfig>
  );
}

export default App;
